export interface MapProps {
  innerRef: React.RefObject<HTMLDivElement>;
}

export const Map = ({ innerRef }: MapProps) => {
  return <div id="map" ref={innerRef} />;
};
